import { render, staticRenderFns } from "./DocumentsHeader.vue?vue&type=template&id=7f540e12"
import script from "./DocumentsHeader.vue?vue&type=script&lang=js"
export * from "./DocumentsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports